
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { NAVIGATION_PAGES } from '@/types/enums';
import AppBadge from './AppBadge.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  emits: ['open-menu'],
  components: {
    AppBadge,
  },
  setup() {
    const route = useRoute();
    const mainStore = useMainStore();

    const currentPage = computed(() => route.meta.navigationPage);

    const isDrive = computed(
      () => !!(
        currentPage.value === NAVIGATION_PAGES.NETWORK
        || currentPage.value === NAVIGATION_PAGES.DRIVE
        || currentPage.value === NAVIGATION_PAGES.CASE_EDIT
        || currentPage.value === NAVIGATION_PAGES.CASE_VIEW
        || currentPage.value === NAVIGATION_PAGES.CASE_CREATE
        || currentPage.value === NAVIGATION_PAGES.DRIVE_PHOTOS
        || currentPage.value === NAVIGATION_PAGES.DRIVE_FILES
        || currentPage.value === NAVIGATION_PAGES.DRIVE_CASES
        || currentPage.value === NAVIGATION_PAGES.DRIVE_FOLDER
      ),
    );
    const badgesContactTab = computed(() => mainStore.badgesContact + mainStore.badgesGroup + mainStore.badgesInGroup);

    return {
      currentPage,
      NAVIGATION_PAGES,
      mainStore,
      isDrive,
      badgesContactTab,
    };
  },
});
